<template>
  <div class="cc-step">
    <div class="cc-content cc-content--products">
      <product v-for="product in products" v-bind:key="createProductKey(product)" :product="product"
               :isEditable="false"/>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-12">
            <div class="cc-content cc-note">
              <div class="cc-form-input">
                <label class="cc-label cc-label--text">{{ translations['Order note'] }}</label>
                <textarea class="cc-input cc-input--text cc-note--input" rows="3" name="note" @change="updateOrderNote">{{ orderNote }}</textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="cc-content cc-content--addresses row">
          <div class="cc-content cc-content--delivery-address col-6">
            <delivery-address-summary/>
          </div>
          <div class="cc-content cc-content--invoice-address col-6" v-if="differentInvoiceAddress">
            <invoice-address-summary/>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="cc-content cc-content--price-tax-excluded">
          <span class="cc-price-label cc-price-label--tax-excluded">{{
              translations['Total price for products tax included']
            }}</span>
          <span class="cc-price cc-price--tax-excluded">{{
              summary.formattedPrices.total_price_products_with_tax
            }}</span>
        </div>
        <div class="cc-content cc-content--price-delivery">
          <div class="cc-content cc-content--price-delivery__label">
            <span class="cc-price-label cc-price-label--delivery">{{
                translations['Total price for delivery tax included']
              }}</span>
            <span class="cc-price-label cc-price-label--delivery-location">({{ currentCarrier.name }})</span>
          </div>
          <div class="cc-content cc-content--price-delivery__price">
            <span class="cc-price cc-price--delivery">{{ shipmentWithPayment.formattedPrice }}</span>
          </div>
        </div>
        <div class="cc-content cc-content--applied-vouchers" v-if="vouchers.length > 0">
          <div class="cc-content cc-content--applied-voucher" v-for="voucher in vouchers" v-bind:key="voucher.code">
            <div class="cc-content cc-content--applied-voucher__name">{{ voucher.name }}</div>
            <div class="cc-content cc-content--applied-voucher__value">{{ voucher.value }}</div>
          </div>
        </div>
        <div class="cc-prices cc-theme__rounding" v-if="rounding">
          <div class="cc-price-label">{{ translations['Rounding according to law'] }}</div>
          <div class="cc-price text-right">{{ formattedRounding }}</div>
        </div>
        <div class="cc-content cc-content--price-tax-included">
          <span class="cc-price-label cc-price-label--tax-included">{{
              translations['Total price tax included']
            }}</span>
          <span class="cc-price cc-price--tax-included">{{ summary.formattedPrices.total_price_tax_included }}</span>
        </div>
        <div class="cc-content cc-content--consents">
          <consents/>
        </div>
        <div class="cc-content cc-content--controls">
          <div class="cc-step-controls">
            <div class="cc-step-controls__section cc-step-controls__section--full">
              <a href="javascript:void(0);" class="cc-button cc-button--finish-order"
                 @click="finishOrder">{{ translations['Finish order'] }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="paymentshooks" style="visibility: hidden; position: absolute" v-html="paymentHooks"></div>
  </div>
</template>

<script>
import {mapState} from "vuex";

import Product from "./Product";
import DeliveryAddressSummary from "./DeliveryAddressSummary";
import InvoiceAddressSummary from "./InvoiceAddressSummary";
import Consents from "./Consents";

export default {
  components: {
    Product,
    DeliveryAddressSummary,
    InvoiceAddressSummary,
    Consents,
  },
  computed: {
    ...mapState({
      translations: state => state.translations,
      products: state => state.products,
      summary: state => state.summary,
      currentCarrier: state => state.currentCarrier,
      differentInvoiceAddress: state => state.user.differentInvoiceAddress,
      activeStep: state => state.activeStep,
      vouchers: state => state.voucher.vouchers,
      carriersPaymentsMap: state => state.carriersPaymentsMap,
      selectedCountry: state => state.user.deliveryAddress.country,
      selectedCarrier: state => state.selectedCarrier,
      selectedPayment: state => state.selectedPayment,
      currentPayment: state => state.currentPayment,
      paymentHooks: state => state.paymentHooks,
      shipmentWithPayment: state => state.shipmentWithPayment,
      orderNote: state => state.orderNote,
      rounding: state => state.roundingSK,
      formattedRounding: state => state.formattedRounding,
    }),
  },
  methods: {
    showLoading: function () {
      const body = document.getElementsByTagName('body')[0];
      const coverSpin = document.createElement('div');
      coverSpin.id = 'cart-cover-spin';
      body.appendChild(coverSpin);
    },
    hideLoading: function () {
      document.getElementById('cart-cover-spin').remove();
    },
    createProductKey: function (product) {
      if (product.id_product && product.id_product_attribute) {
        return product.id_product + '_' + product.id_product_attribute;
      }

      return product.id_product;
    },
    updateOrderNote: function (e) {
      this.$store.commit('SET_ORDER_NOTE', e.target.value);
    },
    finishOrder: function () {
      this.showLoading();

      return this.$store.dispatch('FINISH_ORDER')
          .then((data) => {
            if (data.status === 'error') {
              alert(data.message);
              this.hideLoading();
            }

            if (!this.selectedCountry) {
              this.$store.commit('SET_ACTIVE_STEP', 2);

              document.getElementById('deliveryAddress.country').classList.remove('cc-invalid');
              document.getElementById('deliveryAddress.country').classList.add('cc-invalid');

              document.querySelector('.cc-content--country').scrollIntoView({
                behavior: "smooth",
                block: "start",
              });

              this.hideLoading();

              return;
            } else {
              if (this.activeStep === 2) {
                document.getElementById('deliveryAddress.country').classList.remove('cc-invalid');
              }
            }

            if (!this.selectedCarrier) {
              this.$store.commit('SET_ACTIVE_STEP', 2);

              document.querySelectorAll('.cc-carrier').forEach(item => {
                item.classList.add('cc-invalid')
              });

              document.querySelector('.cc-content--carriers').scrollIntoView({
                behavior: "smooth",
                block: "start",
              });

              this.hideLoading();

              return;
            } else {
              if (this.activeStep === 2) {
                document.querySelectorAll('.cc-carrier').forEach(item => {
                  item.classList.remove('cc-invalid')
                });
              }
            }

            if (!this.selectedPayment) {
              this.$store.commit('SET_ACTIVE_STEP', 2);

              document.querySelectorAll('.cc-payment').forEach(item => {
                item.classList.add('cc-invalid')
              });

              document.querySelector('.cc-content--payments').scrollIntoView({
                behavior: "smooth",
                block: "start",
              });

              this.hideLoading();

              return;
            } else {
              if (this.activeStep === 2) {
                document.querySelectorAll('.cc-payment').forEach(item => {
                  item.classList.remove('cc-invalid')
                });
              }
            }

            if (this.$store.getters.hasUserError) {
              this.$store.commit('SET_ACTIVE_STEP', 3);

              const erroneousInput = document.querySelector('.cc-invalid');

              erroneousInput.parentNode.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });

              this.hideLoading();
              return;
            }

            const carriersPaymentsMapElement = this.carriersPaymentsMap[this.selectedCarrier];

            if (!carriersPaymentsMapElement) {
              alert(this.translations['Invalid carrier/payment combination']);
              this.hideLoading();
              return;
            }

            const selectedPayment = carriersPaymentsMapElement.filter(item => {
              return this.currentPayment.name === item.payment;
            });

            if (selectedPayment.length < 1) {
              alert(this.translations['Invalid carrier/payment combination']);
              this.hideLoading();
            }
          });
    },
  },
  mounted() {
    if (typeof $.uniform !== 'undefined') {
      $('input[type=checkbox]').uniform();
    }
  },
  name: 'Step4A',
};
</script>

<style lang="scss">
#app {
  div {
    &.checker {
      display: inline;

      span {
        top: 1px;
      }
    }
  }
}
</style>

<style lang="scss" scoped="scoped">
@import "./scss/main";

#app {
  .cc-content {
    max-width: 100%;

    &.cc-content--products {
      margin-top: 5rem;
    }

    &.cc-content--price-tax-excluded {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 4rem;
      padding-right: 3rem;
      padding-left: 3rem;
      text-align: right;

      .cc-price-label--tax-excluded {
        font-size: 16px;
        width: 80%;
        text-align: right;
      }

      .cc-price--tax-excluded {
        font-size: 16px;
        width: 20%;
        text-align: right;
      }
    }

    @include mobile {
      &.cc-content--price-tax-excluded {
        margin-top: 2rem;
        padding: 0;

        .cc-price-label--tax-excluded {
          width: 65%;
          text-align: left;
        }

        .cc-price--tax-excluded {
          width: 35%;
        }
      }
    }

    &.cc-content--price-delivery {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 2rem;
      padding-right: 3rem;
      padding-left: 3rem;
      text-align: right;

      .cc-content--price-delivery__label {
        width: 80%;
      }

      .cc-content--price-delivery__price {
        display: flex;
        align-items: center;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-end;
        width: 20%;
      }

      .cc-price-label--delivery {
        font-size: 16px;
        display: block;
        text-align: right;
      }

      .cc-price-label--delivery-location {
        font-size: 12px;
        display: block;
        margin-top: 0.5rem;
        text-align: right;
      }

      .cc-price--delivery {
        font-size: 16px;
      }
    }

    @include mobile {
      &.cc-content--price-delivery {
        padding: 0;

        .cc-content--price-delivery__label {
          width: 65%;
        }

        .cc-content--price-delivery__price {
          width: 35%;
        }

        .cc-price-label--delivery {
          text-align: left;
        }

        .cc-price-label--delivery-location {
          text-align: left;
        }
      }
    }

    &.cc-content--applied-vouchers {
      display: block;
      width: 100%;
      margin-top: 4rem;
    }

    &.cc-content--applied-voucher {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;
      margin-top: 1rem;
      padding-right: 3rem;
      padding-left: 3rem;
      text-align: right;
    }

    &.cc-content--applied-voucher__name {
      font-weight: bold;
      width: 80%;
      font-size: 16px;
    }

    &.cc-content--applied-voucher__value {
      font-weight: bold;
      width: 20%;
      font-size: 16px;
    }

    &.cc-content--price-tax-included {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 2rem;
      padding: 2rem 3rem;
      text-align: right;
      background: $soft-light-grey;

      .cc-price-label--tax-included {
        font-size: 21px;
        width: 80%;
        text-align: right;
      }

      .cc-price--tax-included {
        font-size: 21px;
        width: 20%;
        text-align: right;
      }
    }

    @include mobile {
      &.cc-content--price-tax-included {
        padding: 2rem;

        .cc-price-label--tax-included {
          width: 65%;
          text-align: left;
        }

        .cc-price--tax-included {
          width: 35%;
        }
      }
    }

    &.cc-content--addresses {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
    }

    &.cc-content--delivery-address {
      width: 50%;
      margin-top: 5rem;
    }

    &.cc-content--invoice-address {
      width: 50%;
      margin-top: 5rem;
    }

    @include mobile {
      &.cc-content--delivery-address {
        width: 100%;
        margin-top: 3rem;
      }

      &.cc-content--invoice-address {
        width: 100%;
        margin-top: 3rem;
      }
    }

    &.cc-content--consents {
      margin-top: 5rem;
    }

    @include mobile {
      &.cc-content--consents {
        margin-top: 3rem;
      }
    }

    &.cc-content--controls {
      margin-top: 5rem;
    }

    &.cc-note {
      margin-top: 3rem;

      .cc-note--input {
        max-width: 500px;
        width: 100%;
      }
    }
  }
}
</style>
